/**
* 实名认证 首页
*/
<template>
	<div style="display: flex;flex-direction: column; height: 89vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div>
			<el-alert style="margin:10px 0px;" v-show="successfulOperation" title="操作成功" type="success"
				:description="message" center show-icon>
			</el-alert>
			<el-alert style="margin:10px 0px;" v-show="operationFailed" title="操作失败" type="error" :description="message"
				center show-icon>
			</el-alert>
		</div>

		<!-- 搜索条件 -->
		<div style="margin: 0 10px; display: flex;  margin-bottom: 20px;">

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input1"
				label-width="60px">
				<template slot="prepend">用户ID</template>
			</el-input>
	
			<el-button style="margin-left: 5px;" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
		</div>



		<!-- 列表 -->
		<el-table :data="tableData" height="200" stripe border style="width: 100%; flex: 1; overflow: auto;">
			<el-table-column type="index" :index="indexMethod" align="center"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="164" sortable></el-table-column>
			<el-table-column label="用户ID" align="center" width="94">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 14px;">{{ scope.row.userId }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="nickName" label="用户昵称" align="center" width="164"></el-table-column>


			<el-table-column prop="realName" label="真实姓名" align="center" width="164"></el-table-column>
			<el-table-column prop="idCardNo" label="身份证号码" align="center" width="184"></el-table-column>

			<el-table-column label="身份证正面" prop="imageUrl" width="164" align="center">
				<template slot-scope="scope">
					<a :href="scope.row.cardFrontImg" target="_blank">
						<img :src="scope.row.cardFrontImg" :alt="scope.row.cardFrontImg"
							style="width: 100px; height: 100px; object-fit: contain;" />
					</a>
				</template>
			</el-table-column>

			<el-table-column label="身份证反面" prop="imageUrl" width="164" align="center">
				<template slot-scope="scope">
					<a :href="scope.row.cardBackImg" target="_blank">
						<img :src="scope.row.cardBackImg" :alt="scope.row.cardBackImg"
							style="width: 100px; height: 100px; object-fit: contain;" />
					</a>
				</template>
			</el-table-column>

			<!-- <el-table-column label="手持身份证" prop="imageUrl" width="144" align="center">
				<template slot-scope="scope">
					<a :href="scope.row.cardHandImg" target="_blank">
						<img :src="scope.row.cardHandImg" :alt="scope.row.cardHandImg"
							style="width: 100px; height: 100px; object-fit: contain;" />
					</a>
				</template>
			</el-table-column> -->

			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button v-show="scope.row.personalVerifyStatus==0" @click="agree(scope.$index)" type="success"
						size="small">同意</el-button>
					<el-button v-show="scope.row.personalVerifyStatus==0" @click="banAccount(scope.$index)"
						type="danger" size="small">拒绝</el-button>
					<p v-show="scope.row.personalVerifyStatus==1" style="font-size: 14px; color: #0cf520;">已同意</p>
					<p v-show="scope.row.personalVerifyStatus==2" style="font-size: 14px; color: #f50c27;">已拒绝</p>
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				input1: '', //用户ID
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				message: "", //提示的内容
				successfulOperation: false, //操作成功
				operationFailed: false, //操作失败
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //语音房 实名认证列表
		},
		methods: {
			fetchData(pageNum, pageSize) { //语音房 实名认证列表
				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.input1.length > 0) { //用户ID
					requestData.userId = this.input1;
				}

				console.log("语音房 实名认证列表  发送的数据：", requestData)

				axios.post(this.$p_url + '/voiceRoom/H5/getVoiceRoomBasicUserInfoOfPage', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("语音房 实名认证列表  后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							this.total = response.data.data.total; //一共有多少条数据

							for (let i = 0; i < response.data.data.list.length; i++) {
								//身份证正面
								response.data.data.list[i].cardFrontImg = this.$p_urlImage + response.data.data.list[i]
									.cardFrontImg;
								//身份证反面
								response.data.data.list[i].cardBackImg = this.$p_urlImage + response.data.data.list[i]
									.cardBackImg;
								//手持身份证
								response.data.data.list[i].cardHandImg = this.$p_urlImage + response.data.data.list[i]
									.cardHandImg;
							}

							this.tableData = response.data.data.list;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			agree(index) { //同意
				const requestData = {}; //传递的参数
				axios.post(this.$p_url + '/voiceRoom/H5/operateBasicUserInfoVerifyStatus/' + this.tableData[index].id +
						'/' + 1, requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.message = "已同意!";
							this.successfulOperation = true;
							this.fetchData(1, 20);
						} else {
							this.message = response.data.message;
							this.operationFailed = true;
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			banAccount(index) { //拒绝
				const requestData = {}; //传递的参数
				axios.post(this.$p_url + '/voiceRoom/H5/operateBasicUserInfoVerifyStatus/' + this.tableData[index].id +
						'/' + 2, requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.message = "已拒绝!";
							this.successfulOperation = true;
							this.fetchData(1, 20);
						} else {
							this.message = response.data.message;
							this.operationFailed = true;
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			search() { //单击了搜索
				this.fetchData(1, this.pageSize);
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			//...
		}
		//...
	}
</script>

<style>
</style>